const constants = {
  keys: [
    "q",
    "w",
    "e",
    "r",
    "t",
    "y",
    "u",
    "i",
    "o",
    "p",
    "a",
    "s",
    "d",
    "f",
    "g",
    "h",
    "j",
    "k",
    "l",
    "z",
    "x",
    "c",
    "v",
    "b",
    "n",
    "m",
  ],
  frazez: {
    books: [
      { "prickled feathered friends": "Thorn Birds" },
      { "conflict and harmony": "War and Peace" },
      { "a story about 2 towns": "A Tale of Two Cities" },
      { "small females": "Little Women" },
      { "an adieu to weapons": "A Farewell to Arms" },
      { "the scarlet symbol": "The Red Letter" },
      { "eden misplaced": "Paradise Lost" },
      { "seraphs and devils": "Angels and Demons" },
      { "the ancient male and the ocean": "The Old Man and the Sea" },
      { "the anguish and the joy": "The Agony and the Ecstacy" },
      { "vessel of clowns": "Ship of Fools" },
      { twosomes: "Couples" },
      { "prosperous male destitute male": "Rich Man Poor Man" },
      { "polar opposites": "North and South" },
      { "believed blameless": "Presumed innocent" },
      { "huge hopes": "Great Expectations" },
      { "the crimson brooch of bravery": "The Red Badge of Courage" },
      { "offence and penalty": "Crime and Punishment" },
      { "the unseen male": "The Invisible Man" },
      { "pastime of dynasties": "Game of Thrones" },
      { hell: "Inferno" },
      { "beneath the spherical roof": "Under the Dome" },
      { "ravenous contests": "Hunger Games" },
      { "the literary crook": "The Book Thief" },
      { "the small monarch": "The Little Prince" },
      { "ponder and acquire wealth": "Think and Grow Rich" },
      { "the cheerful prostitute": "The Happy Hooker" },
      { "the tabby in the headgear": "The Cat in the Hat" },
      { "luminary conflicts": "Star Wars" },
      { "wealthy papa beggared papa": "Rich Dad Poor Dad" },
      { "ghost of the music hall": "Phantom of the Opera" },
      { "eden misplaced": "Paradise Lost" },
      {
        "a sequence of inauspicious happenings":
          "A Series of Unfortunate Events",
      },
      { "joy is a hot dog": "Happiness is a Warm Puppy" },
      { "gender and the unattached female": "Sex and the Single Girl" },
      { "beast ranch": "Animal Farm" },
      { "godlike satire": "Divine Comedy" },
      { "the extremely starving worm": "The Very Hungry Caterpillar" },
      { "gloomy dwelling": "Bleak House" },
      { "wilderness novel": "Jungle Book" },
      { "crimson note": "Scarlet Letter" },
      { "beast pasture": "Animal Farm" },
      { "journal of a feeble youngster": "Diary of a Wimpy Kid" },
      { "return to the forthcoming": "Back to the Future" },
      { "disdain and bigotry": "Pride and Prejudice" },
      { "the castle documents": "The Palace Paperrs" },
      { "soaring paper and string sprinter": "The Kite Runner" },
    ],
    cartoons: [
      { "psycho melodies": "Looney Tunes" },
      { "vermin hare": "Bugs Bunny" },
      { "street sprinter": "Roadrunner" },
      { "nutty bird": "Daffy Duck" },
      { "cat and mouse": "Tom and Jerry" },
      { "joy juice rodent": "Mickey Mouse" },
      { "old man optic": "Popeye" },
      { "small female rodent": "Mini Mouse" },
      { meddlesome: "Snoopy" },
      { "swine oinker": "Porky Pig" },
      { "chirpy tart": "Tweety Pie" },
      { "jungly lumber snout": "Woody Woodpecker" },
      { "bottom skull": "ButtHead" },
      { "imposing vermin": "Mighty Mouse" },
      { "daffy hound": "Goofy Dog" },
      { "marvel lady": "Wonder Woman" },
    ],
    cliches: [
      { "evil omen": "Bad Egg" },
      { "Godspeed in camouflage": "Blessing in Disguise" },
      { "drone in your cap": "Bee in Your Bonnet" },
      { "ten cents a boxcar": "Dime a Dozen" },
      { "punch the bag": "Hit the Sack" },
      { "a blemish on the view": "A Blot on the Landscape" },
      { "utter of the fiend": "Speak of the Devil" },
      { "a stag in an asian store": "A Bull in a China Shop" },
      { "flawless tempest": "Perfect Storm" },
      { "increase slander to harm": "Add Insult to Injury" },
      { "crash the glacier": "Break the Ice" },
      { "a cheap knock-off": "Poor Replica" },
      { "illiteracy is joy": "Ignorance is Bliss" },
      { "challenge diablo's defender": "Play Devil's Advocate" },
      { "stag's optic": "Bull's Eye" },
      { "beneath the climate": "Under the Weatheer" },
      { "cook's twelve": "Baker's Dozen" },
      { "a dead ringer": "Deceased Tone" },
      { "masticate the projectile": "Bite the Bullet" },
      { "dark lambs": "Black Sheep" },
      { "smash the frozen liquid": "Break the Ice" },
      { "scorch the 12 o'clock grease": "Burn the Midnight Oil" },
      { "inter the axe": "Bury the Hatchet" },
      { "palaces in the atmosphere": "Castles in the Air" },
      { "frigid fowl": "Cold Turkey" },
      { "steed of another shade": "Horse of a Different Color" },
      { "boot the pale": "Kick the Bucket" },
      { "wrap on lumber": "Knock on Wood" },
      { "final chuckle": "Last Laugh" },
      { "pinch and fold": "Nip and Tuck" },
      { "ancient cap": "Old Hat" },
      { "draw the village crimson": "Paint the Town Red" },
      { "a buffoon's eden": "A Fool's Paradise" },
      { "yank a body's limb": "Pull Somebody's leg" },
      { "pouring felines and canines": "Raining Cats and Dogs" },
      { "ocean limbs": "Sea Legs" },
      { "submerge or bathe": "Sink or Swim" },
      { "carcass in the cabinet": "Skeleton in th Closet" },
      { "whiff a rodent": "Smell a Rat" },
      { "bitter fruits": "Sour Grapes" },
      { "rod of existence": "Staff of Life" },
      { "odd allies": "Strange Bedfellows" },
      { "test inflatable": "Trial Balloon" },
      { "battle stallion": "War Horse" },
      { "explosive crate": "Bom Box" },
      { "fracture a limb": "Break a Leg" },
      { "sofa spud": "Couch Potato" },
      { "top boss": "Head Honcho" },
      { "smack the bag": "Hit the Sack" },
      { "trash correspondence": "Junk Mail" },
      { "satans supporter": "Devils Advocate" },
      { "wobbly gun": "Loose cannon" },
      { "jiggle a limb": "Shake a Leg" },
      { "bind the loop": "Tie the Knot" },
      { "female chance": "Lady Luck" },
      { "ancient peoples places": "Old Folks Home" },
      { "warm abode": "Hot House" },
      { "pink-tinted specs": "Rose-Colored Glasses" },
      { "colored submersible": "Yellow Submarine" },
      { "deserving foe": "Worthy Opponent" },
      { "language openings": "French Doors" },
      { "frightened feline": "Scardie Cat" },
      { "untrue deity": "False God" },
      { "pc guru (genius)": "Computer Whiz (Nerd)" },
      { "eating place": "Dining Room" },
      { "washroom parchment": "Toilet Paper" },
      { "odd bunkmates": "Strange Bedfellows" },
      { "plead the inquiry": "Beg the Question" },
      { "large enterprise": "Big Business" },
      { "large ladle": "Big Dipper" },
      { "an essential immorality": "A necessary Evil" },
      { "breeding management": "Birth Control" },
      { "chomp the dirt": "Bite the Dust" },
      { "ebony demise": "Black Death" },
      { "inky chasm": "Black Hole" },
      { "sightless stain": "Blind Spot" },
      { "blazing shrub": "Burning Bush" },
      { "superior penalty": "Capital Punishment" },
      { "tote the beacon": "Carry the Torch" },
      { "incessant ailment": "Chronic Disease" },
      { "poultry disease": "Chicken Pox" },
      { "infectious ailment": "Contagious Disease" },
      { "fake currency": "Counterfeit Money" },
      { "canine home": "Dog House" },
      { "twofold woes": "Double Trouble" },
      { "parallel chance": "Equal Opportunity" },
      { "obese feline": "Fat Cat" },
      { "spring of adolescence": "Fountain of Youth" },
      { "endless dreamer": "Eternal Optimist" },
      { "boot the can": "Kick the Bucket" },
      { "musket nuptials": "Shotgun Wedding" },
      { "yank cords": "Pull Strings" },
      { "speechless plurality": "Silent Majority" },
      { "impromptu explosion": "Spontaneous combustion" },
      { "bold prevaricator": "Barefaced Liar" },
      { "gnaw the lard": "Chew the Fat" },
      { "ape work": "Monkey Business" },
      { "phantom author": "Ghost Writer" },
      { "tatters to wealth": "Rags to Riches" },
      { "a winning combination": "Successful Merger" },
      {
        "fumigating your soiled clothes with everyone":
          "Airing your Dirty Laundry in Public",
      },
    ],
    clothes: [
      { "hide blazer": "Leather Jacket" },
      { "concubine trouserrs": "Harem Pants" },
      { "ninja footwear": "Gladiator Sandals" },
      { "scrawny dungarees": "Skinny Jeans" },
      { "cook's coverup": "Chef's Apron" },
      { "bridal dress": "Wedding Gown" },
      { "abreviated trousers": "Short Shorts" },
      { "long gown": "Maxi Dress" },
      { "evening attire": "Night Gown" },
      { "wrangler footwear": "Cowboy Boots" },
      { "racing footwear": "Running shoes" },
      { "muffle litters": "Hush Puppies" },
      { "steamy men's attire": "Sweatsuit" },
      { "flip flounder": "Flip-flop" },
    ],
    "common phrases": [
      { "boot the pail": "Kick the Bucket" },
      { "rap on lumber": "Knock on Wood" },
      { "final chuckle": "Last Laugh" },
      { "pinch and fold": "Nip and Tuck" },
      { "ancient cap": "Old Hat" },
      { "color the village crimson": "Paint the Town Red" },
      { "yank a body's limb": "Pull Somebody's Leg" },
      { "pouting felines and canines": "Pouring Cats and Dogs" },
      { "ocean limbs": "Sea Legs" },
      { "submeerge or bathe": "Sink of Swim" },
      { "carcass in the wardrobe": "Skeleton in the Closet" },
      { "whiff a rodent": "Smell a Rat" },
      { "bitter fruit": "Sour Grapes" },
      { "rod of existence": "Staff of Life" },
      { "strange bunkmates": "Odd Couple" },
      { "experimental inflatable": "Trial Balloon" },
      { "battle stallion": "War Horse" },
      { "explosive crate": "Boom Box" },
      { "fracture a limb": "Break a Leg" },
      { "sofa spud": "Couch Potato" },
      { "top boss": "Head Honcho" },
      { "smack the bag": "Hit the Sack" },
      { "trash correspondence": "Junk Mail" },
      { "satan's supporter": "Devil's Advocate" },
      { "wobbly gun": "Loose Canyon" },
      { "jiggle a limb": "Shake a Leg" },
      { "pc nerd": "Computer Geek" },
      { "stomach hole": "Abdominal Cavity" },
      { "drone in your hat": "Bee in your Bonnet" },
      { "plead the inquiry": "Beg the Question" },
      { "large enterprise": "Big Business" },
      { "large ladle": "Big Dipper" },
      { "breeding management": "Birth Control" },
      { "chomp the dirt": "Bite the Dust" },
      { "ebony demise": "Black Death" },
      { "inky chasm": "Black Hole" },
      { "sightless stain": "Blind Spot" },
      { "blazing shrub": "Burning Bush" },
      { "superior penalty": "Capital Punishment" },
      { "tote the beacon": "Carry the Torch" },
      { "incessant ailment": "Chronic Disease" },
      { "poultry disease": "Chicken Pox" },
      { "infectious ailment": "Contagious Disease" },
      { "fake currency": "Counterfeit Money" },
      { "canine home": "Dog House" },
      { "twofold woes": "Double Trouble" },
      { "parallel chance": "Equal Opportunity" },
      { "lollypop hit": "Sucker Punch" },
      { "sightless fury": "Blind Rage" },
      { "toddler speech": "BabyTalk" },
      { "oil consumer": "Gas Guzzler" },
      { "arid dermis": "Dry Skin" },
      { "obese opportunity": "Fat Chance" },
      { "dark witchcraft": "Black Magic" },
      { "culpable enjoyment": "Guilty Pleasure" },
      { "content as a mollusk": "Happy as a Clam" },
      { "awful tresses now": "Bad Hair Day" },
      { "torch a path": "Blaze a Trail" },
      { "deceased bell": "Dead Ringer" },
      { "elegant trousers": "Fancy Pants" },
      { "dirty wealth": "Filthy Rich" },
      { "humorous ranch": "Funny Farm" },
      { "weighty steel": "Heavy Metal" },
      { "grasp your steed": "Hold Your Horses" },
      { "native season": "Indian Summer" },
      { "marsupial tribunal": "Kangaroo Court" },
      { "blessed ovine": "Sacred Cow" },
      { "surveillance cover": "Security Blanket" },
      { "zilch compassion": "Zero Tolerance" },
      { "simple as pastry": "Easy as Pie" },
      { "cheerful as a crustacean": "Happy as a Clam" },
      { "vaulting the weapon": "Jumping the Gun" },
      { "a male of little discussion": "A Man of Few Words" },
      { "fast and soiled": "Quick and Dirty" },
      { "the plot coagulates": "The Plan Thickens" },
      { "toss in the napkin": "Throw in the Towel" },
      { "unattractive poultry": "Ugly Duckling" },
      { "below your snout": "Under Your Nose" },
      { "absolve and obliterate": "Forgive and Forget" },
      {
        "if it isn't damage don't repair it": "If it Ain't Broke Don't Fix it",
      },
      { "cash speaks": "Money Talks" },
      { "chomp the lard": "Chew the Fat" },
      { "taut epidermis": "Dry Skin" },
      { "warm abode": "Hot House" },
      { "female lucifer": "She Devil" },
      { "slice of tart": "Piece of Pie" },
      { "ocean gams": "Sea Legs" },
      { "nuptial oaths": "Wedding Vows" },
      { "parting pace": "Separation Agreement" },
      { "sudden closure": "Abrupt Ending" },
      { "manly acquiescence": "Gentleman's Agreement" },
      { "firm agreement": "Hard Bargain" },
      { "admonitory chimes": "Warning Bells" },
      { "preferable conditions": "Fair Advantage" },
      { "tatters to affluence": "Rags to Riches" },
      { "aggressive control": "Hostile Take-Over" },
      { "comprehensive holiday": "All Inclusive Vacation" },
      { "unrestrictive conflict": "All Out War" },
      { "amply evident": "Abundantly Clear" },
      { "unnamed giver": "Anonymous Donor" },
      { "old sailor": "Ancient Mariner" },
      { "pink tinted specs": "Rose Colored Glasses" },
      { "trip restriction": "Travel Ban" },
      { "cycle lane": "Bike Path" },
      { "street fury": "Road Rage" },
      { "wharf illumination": "Harbor Lights" },
      { "patella dope": "Knee Jerk" },
      { "hasty conduct": "Impulsive Behavior" },
      { "detached artillery": "Loose Cannon" },
      { "tummy fastener": "Belly Button" },
      { "champion stag": "Prize Bull" },
      { "molar shovel": "Tooth Pick" },
      { "blooming painter": "Budding Artist" },
      { "poultry fodder": "Chicken Feed" },
      { "acid wines": "Sour Grapes" },
      { "phantom village": "Ghost Town" },
      { "luxurious impoundment": "Gilded Cage" },
      { "chilly tooties": "Cold Feet" },
      { "drafty fowl": "Cold Turkey" },
      { "aligator sobs": "Crocodile Tears" },
      { "saucy caboose": "Gravy Train" },
      { "alabaster belfry": "Ivory Tower" },
      { "hank cords": "Pull Strings" },
      { "divine bovine": "Holy Cow" },
      { "peculiar lodgers": "Strange Bedfellows" },
      { "speak fowl": "Talk Turkey" },
      { "wicked sphere": "Vicious Circle" },
      { "strolling document": "Walking Papers" },
      { "damp coverlet": "Wet Blanket" },
      { "digit aiming": "Finger Pointing" },
      { "letter ship": "U Boat" },
      { "fruit nations": "Banana Republics" },
      { "same chance": "Equal Opportunity" },
      { "best male heir": "Favorite Son" },
      { "family boat": "Kinship" },
      { "blended wedding": "Mixed Marriage" },
      { "parchment purse": "Paper Bag" },
      { "mute medication": "Silent Treatment" },
      { "slicing rim": "Cutting Edge" },
      { "reliable karma": "Good Luck" },
      { "obsene swine": "Fat Pig" },
      { "sanguinary demise": "Bloody Murder" },
      { "nitwit validation": "Idiot Proof" },
      { "plumed pal": "Feathered Friend" },
      { "tin of snakes": "Can of Worms" },
      { "picture end": "Photo Finish" },
      { "quadriped donkey": "Horse's Ass" },
      { "royal drone": "Queen Bee" },
      { "fast mend": "Quick Fix" },
      { "big cat's portion": "Lion's share" },
      { "grade performance": "Class Act" },
      { "churn the dingy": "Rock the Boat" },
      { "moola speaks": "Money Talks" },
      { "koala justice": "Kangaroo Court" },
      { "deformed quacker": "Lame Duck" },
      { "parchment cougar": "Paper Tiger" },
      { "duckling aria": "Swan Song" },
      { "twice hexed": "Double Whammy" },
      { "dirty wealth": "Filthy Rich" },
      { "patella dope response": "Knee Jerk Reaction" },
      { "stinky drama": "Foul Play" },
      { "sofa spud": "Couch Potato" },
      { "fluffy feel": "Soft Touch" },
      { "ideal emotion": "Good Vibes" },
      { "hay stack": "Straw Pole" },
      { "blended affections": "Mixed Feelings" },
      { "revered panic": "Holy Terror" },
      { "juvenile outburst": "Teenage Tantrum" },
      { "soiled nappies": "Dirty Diapers" },
      { "inferno blizzard": "Fire Storm" },
      { "route astute": "Street Wise" },
      { "fury control": "Anger Management" },
      { "verbalizing credibility": "Talking Points" },
      { "appauling illiteracy": "Woeful Ignorance" },
      { "bounce ahead": "Spring Forward" },
      { "stumble astern": "Fall Back" },
      { "deceptive revelation": "Fake News" },
      { "cackle crate": "Squawk Box" },
      { "programmed demise": "planned obsolesence" },
      { "nibble the lard": "Chew the Fat" },
      { "chance raps": "Opportunity Knocks" },
      { "junk lecture": "Trash Talk" },
      { "wealth cleansing": "Money Laundering" },
      { "universal heating": "Global Warming" },
      { "cerebral decline": "Mental Lapse" },
      { "stress the certainty": "Accentuate the Positive" },
      { "sorcerers chase": "Witch Hunt" },
      { "angling excursion": "Fishing Exedition" },
      { "reciprocal idolotry": "Mutual Admiration" },
      { "damp quilt": "Wet Blanket" },
      { "unjustified guilt": "Presumed Innocent" },
      { "injurious aftermath": "Adverse Reaction" },
      { "fool's reward": "Booby Prize" },
      { "cheerful as a mollusk": "Happy as a Clam" },
      { "sever the condiment": "Cut the Mustard" },
      { "cease frigid fowl": "Quit Cold Turkey" },
      { "slap under the cincture": "Hit Below the Belt" },
      { "revolve with the jabs": "Roll With the Punches" },
      { "effortless cash": "Easy Money" },
      { "moola speaks": "Money Talks" },
      { "dough to char": "Money to Burn" },
      { "stationary birds": "Sitting Ducks" },
      { "striking a lifeless nag": "Beating a Dead Horse" },
      { "weep coyote": "Cry Wolf" },
      { "den of snakes": "Nest of Vipers" },
      { "pitiful appearance": "Sorry Sight" },
      { "awful coiffure time": "Bad Hair Day" },
      { "nip the dirt": "Bite the Dust" },
      { "fire a route": "Blaze a Trail" },
      { "cartilage parched": "Bone Dry" },
      { "nitwit snare": "Booby Trap" },
      { "suspenseful situation": "Cliff Hanger" },
      { "dirty drama": "Foul Play" },
      { "cap strategy": "Hat Trick" },
      { "cartilage parched": "Bone Dry" },
      { "character robbery": "Identity Theft" },
      { "sick breeze": "Ill Wind" },
      { "crippled bird": "Lame Duck" },
      { "final hay": "Last Straw" },
      { "mad brink": "Lunatic Fringe" },
      { "recollection road": "Memory Lane" },
      { "crumble chats": "Mince Words" },
      { "original shape": "Mint Condition" },
      { "horde of transgressions": "Multitude of Sins" },
      { "cleaning the cask": "Scraping the Barrel" },
      { "ailing canine": "Sick Puppy" },
      { "bucks to tarts": "Dollars to Donuts" },
      { "burrow ages": "Donkey Years" },
      { "speechless bleach": "Dumb Blonde" },
      { "racial purification": "Ethnic Cleansing" },
      { "dirty wealth": "Filthy Rich" },
      { "jerk's task": "Fool's Errand" },
      { "idiots nuggets": "Fool's Gold" },
      { "nitwit's eden": "Fool's Paradise" },
      { "outlawed harvest": "Forbidden Fruit" },
      { "inevitable end": "Foregone Conclusiion" },
      { "newcomer's chance": "Beginner's Luck" },
      { "crash the vault": "Break the Bank" },
      { "create backlash": "Make Waves" },
      { "evident as sludge": "Clear as Mud" },
      { "frigid as gravel": "Cold as Stone" },
      { "obese fate": "Fat Chance" },
      { "bulky as bandits": "Thick as Thieves" },
      { "jab inebriated": "Punch Drunk" },
      { "pebbbles toss": "Stones Throw" },
      { "duck tune": "Swan Song" },
      { "kodak timid": "Camera Shy" },
      { "link the bow": "Tie the Knot" },
      { "mesh of deception": "Web of Lies" },
      { "chilly tooties": "Cold Feet" },
      { "chief mutt": "Top Dog" },
      { "fang and tack": "Tooth and Nail" },
      { "feel lumber": "Touch Wood" },
      { "citadel of stamina": "Tower of Strength" },
      { "prank or goodie": "Trick or Treat" },
      { "anguish and struggle": "Trouble and Strife" },
      { "beneath coverings": "Under Wraps" },
      { "civil legend": "Urban Myth" },
      { "feeblest connection": "Weakest Link" },
      { "rest snugly": "Sleep Tight" },
      { "mush bankroll": "Slush Fund" },
      { "noise nip": "Sound Bite" },
      { "spoiled wines": "Sour Grapes" },
      { "spew the seeds": "Spill the Beans" },
      { "slobber icon": "Spitting Image" },
      { "rectangular dinner": "Square Meal" },
      { "crock chance": "Pot Luck" },
      { "over broad and lean": "Through Thick and Thin" },
      { "stubby as crooks": "Thick as Thieves" },
      { "reasoning beret": "Thinking Cap" },
      { "titilate the piano": "Tickle the Ivories" },
      { "don the trousers": "Wear the Pants" },
      { "savage and bushy": "Wild and Wooly" },
      { "rowdy peasant hunt": "Wild Goose Chase" },
      { "behind on chairs": "Bums on Seats" },
      { "choice hour": "Prime Time" },
      { "regal's bride": "King's Queen" },
      { "sphere and link": "Ball and Chain" },
      { "pathetic vision": "Sorry Sight" },
      { "parchment cougar": "Paper Tiger" },
      { "uncontrained gun": "Loose Cannon" },
      { "etch a void": "Draw a Blank" },
      { "boar in the den": "Elephant in the Room" },
      { "protected wager": "Safe Bet" },
      { "grasp your nags": "Hold Your Horses" },
      { "deluge control": "Rain check" },
      { "execute existence": "Kill Time" },
      { "existence glides": "Time flies" },
      { "gushing kittens and mutts": "Raining Cats and Dogs" },
      { "smack the research": "Hit the Books" },
      { "scraps to wealth": "Rags to Riches" },
      { "coequal burden": "Peer Pressure" },
      { "ailing dog": "Sick Puppy" },
      { "verse or logic": "Rhyme or Reason" },
      { "execute the courrier": "Shoot the Messenger" },
      { "fortune raps": "Opportunity Knocks" },
      { "computing herd": "Counting Sheep" },
      { "kill the satelite": "Shoot the Moon" },
      { "loaded to the brink": "Stuffed to the Brim" },
      { "dawdler's tempo": "Snail's Pace" },
      { "patella idiot": "Knee Jerk" },
      { "headdress of secrecy": "Veil of Silence" },
      { "bribe rear": "KickBack" },
      { "fellow lifestyle": "Creature Comfort" },
      { "concealed program": "Hidden Agenda" },
      { "break, fracture, dad": "Snap Crackle Pop" },
      { "stag exchange": "Bull Market" },
      { "developing throbs": "Growing Pains" },
      { "column of durability": "Pillar of Strength" },
      { "larger than existence": "Bigger Than Life" },
      { "beastly strength": "Brute Force" },
      { "weather alteration": "Climate Change" },
      { "wipeout lifestyle": "Cancel Culture" },
      { "the final discussion": "The Last Word" },
      { "intellect chill": "Brain Freeze" },
      { "mind mist": "Brain Fog" },
      { "deceased core": "Dead Center" },
      { "distribute and vanquish": "Divide and Conquer" },
      { expressionless: "Deadpan" },
      { "mix mad": "Stir Crazy" },
      { "decal cost": "Sticker Price" },
      { "blunder signal": "Spoiler Alert" },
      { "spew blaze": "Spitfire" },
      { "scale of achievement": "Ladder of Success" },
      { "associate system": "Corporate Ladder" },
      { "speechless cure": "Silent Treatment" },
      { "dependable experts": "Reliable Sources" },
      { "exceptional condition": "Special Status" },
      { "soar beneath the sonar": "Fly Under the Radar" },
      { "hound blare": "Dog Whistle" },
      { "cost fixing": "Price Gauging" },
      { "chubby gamble": "Fat Chance" },
      { "sway the barge": "Rock the Boat" },
      { "stretch for the dazzlers": "Reach for the Stars" },
      { "diversified assignment": "Multi-Tasking" },
      { "veracity is odder than fantasy": "Truth is Stranger than Fiction" },
      { "emphasize the certainty": "Accentuate the Positive" },
      { "labor from your castle": "Work From Home" },
      { "blah chopped steak": "Nothing Burger" },
      { "corpse of fibs": "Body of Lies" },
      { "squabble comp": "Hassle Free" },
      { "marsupial tribunal": "Kangaroo Court" },
      { "equipped and deadly": "Armed and Dangerous" },
      { "punitive action": "Poetic Justice" },
      { "reach an agreement": "Strike a Bargain" },
      { "ogle sweets": "Eye Candy" },
      { "stag's optic": "Bull's Eye" },
      { "phantom pistol": "Ghost Gun" },
      { "ape commerce": "Monkey Business" },
      { "satan's supporter": "Devil's Advocate" },
      { "detached artillery": "Loose Cannon" },
      { "alabaster fortress": "Ivory Tower" },
      { "conceptual paintting": "Abstract Art" },
      { "chump assault": "Sucker Punch" },
    ],
    companies: [
      { "mug novel": "Facebook" },
      { "legendary female warrior": "Amazon" },
      { "clock sound": "TikTok" },
      { "celebrity moola": "Starbucks" },
      { "mini smooth": "Microsoft" },
      { "not first mug": "Second Cup" },
      { "gallery help": "KitchenAid" },
      { "barrier mall": "Walmart" },
      { "heft guards": "Weight Watchers" },
      { "ultimate purchase": "Best Buy" },
      { "regal vault": "Royal Bank" },
      { "greenback sapling": "Dollar Tree" },
      { "salary friend": "Paypal" },
      { "flurry pond": "Whirlpool" },
      { "ebony stone": "Black Rock" },
      { "move father": "Godaddy" },
      { "birdie's song": "Twitter" },
      { "divider legumes": "Walgreens" },
      { "the nutritional pathway": "The Food Channel" },
      { "cost boundary": "Priceline" },
      { "cougars portal": "Lionsgate" },
      { "fantasy labors": "Dreamworks" },
    ],
    dance: [
      { "coyote jog": "Fox Trot" },
      { "chic bounce": "Hip Hop" },
      { "unclean tango": "Dirty Dancing" },
      { "gyrate pest": "Jitterbug" },
      { "the crushed spud": "The Mashed Potato" },
      { "the crazy movement": "The Loco-Motion" },
      { "the ogre crush": "The Monster Mash" },
      { "the flowerchild twirl": "The Hippie Spin" },
      { "the men's abode dance": "Y.M.C.A." },
      { "satelite stroll": "MoonWalk" },
      { "row jiving": "Line Dancing" },
      { "instant crowd movements": "Flash Mob Dance" },
      { "tummy rumble": "Belly Dance" },
      { "hare bounce": "Bunny Hop" },
    ],
    "fictional characters": [
      { "the colored ogre": "The Green Giant" },
      { "extra ordinary male": "Superman" },
      { "wadding weight animal": "Paddington Bear" },
      { "gloomy harvester": "Grim Reaper" },
      { "joy juice rodent": "Mickey Mouse" },
      { "vermin hare": "Bugs Bunny" },
      { "winged male": "Batman" },
      { "arachnid dude": "SpiderMan" },
      { kidder: "Joker" },
      { "metal male": "Iron Man" },
      { "dad optic": "Popeye" },
      { "greetings pussy": "Hello Kitty" },
      { "pretending pal": "Imaginary Friend" },
      { "soaring rug": "Flying Carpet" },
      { "decapitated male rider": "Headless Horseman" },
    ],
    food: [
      { "ebony fruits": "Blackberries" },
      { "asian carryout": "Chinese Food" },
      { "lucifer's snack loaf": "Devil's Food Cake" },
      { "beef ammo": "Meat Ball" },
      { "shallot circles": "Onion Rings" },
      { "grain custard": "Rice Pudding" },
      { "satan's roe": "Devil Eggs" },
      { "crustacean broth": "Clam Chowder" },
      { "bellyachers tart": "Crab Cake" },
      { "bloated scone": "Puffed Pastry" },
      { "fabric sweets": "Cotton Candy" },
      { "poultry brochettes": "Chicken Skewers" },
      { "jam buns": "Jelly Donuts" },
      { "spud crepes": "Potato Pancakes" },
      // { "fowl legs": "Chicken/Turkey Legs" },
      { "messy caffeine mutts": "Sloppy Joe Dogs" },
      { "dad pies": "PopTarts" },
      { "fowl claws": "Chicken Fingers" },
      { "ebony fruits": "Blackberries" },
      { "asian carryout": "Chinese Food" },
      { "aperatif frankfurter": "Cocktail Sausage" },
      { "dog nourishment": "Pet Food" },
      { "foreign spuds": "French Fries" },
      { "hare goulash": "Rabbit Stew" },
      { "skillet pastry": "Pancake" },
      { "skillet sizzle": "Pan Fry" },
      { "creature biscuits": "Animal Crackers" },
      { "dodge broth": "Duck Soup" },
      { "lillipution pastries": "Miniature Cakes" },
      { "moo-juice tremor": "Milk Shake" },
      { "crustacean cream": "Lobster Bisque" },
      { "wealth biscuit": "Fortune Cookie" },
      { "sizzling cur": "Hot Dog" },
      { "potato infants": "Tatter Tots" },
      { "bird beneath the mirror": "Pheasant Under Glass" },
      { "tatter crepes": "Potato Pancakes" },
      { "poached ovum": "Coddled Egg" },
      { "herder's tart": "Shepherd's Pie" },
      { "cookout curved bones": "Barbecue Ribs" },
      { "swine trotters": "Pigs Feet" },
      { "hogs hip": "Pork Loin" },
      { "tugged hog": "Pulled Pork" },
      { "klutz rear": "Ox Tail" },
      { "frozen homogenized sabbath": "Ice Cream Sundae" },
      { "boiling puppy": "Hot Dog" },
      { "tambour twigs": "Drum Sticks" },
      { "fowl appendage": "Chicken Wing" },
      { "rooster dressing": "Turkey Stuffing" },
      { "nuptial tart": "Wedding Cake" },
      { "poultry claws": "Chicken Fingers" },
    ],
    games: [
      { "inconsequential hobby": "Trivial Pursuit" },
      { "prisons and hydras": "Dungeons and Dragons" },
      { "sidestep globe": "Dodge Ball" },
      { "conceal and explore": "Hide and Seek" },
      { "arrest the penant": "Capture the Flag" },
      { "unseeing male pretense": "Blind Man's Bluff" },
      { "melodic seats": "Musical Chairs" },
      { "quarry skill": "Mine Craft" },
      { "impressive heist car": "Grand Theft Auto" },
      { "eliminator's doctrine": "Assassins Creed" },
      { "tenant immorality": "Resident Evil" },
      { "hydra sphere": "Dragon Ball" },
      { "opposing protest": "Counter Strike" },
      { "enraged flock": "Angry Birds" },
      { "jump toad": "Leap Frog" },
      { "lint ammo": "Fuzz Ball" },
      { "gherkin sphere": "Pickle Ball" },
      { "impressive sound": "Grand Slam" },
      { "circle fling": "Ring Toss" },
      { "jumping cord": "Skipping Rope" },
      { "disc of fate": "Wheel of Fortune" },
    ],
    movies: [
      { "pulverized story": "Pulp Fiction" },
      { "admission of an alarming brain": "Confessions of a Dangerous Mind" },
      { "typical offenders": "Usual Suspects" },
      { "endurance male": "Marathon Man" },
      { "calling cubicle": "Phone Booth" },
      { "the man with the gilded pistol": "The Man with the Golden Gun" },
      { "boxing organization": "Fight Club" },
      { "Poultry broth": "Duck Soup" },
      { "grab the cash and race": "Take the Money and Run" },
      { "the rose-colored cougar": "The Pink Panther" },
      { "the nude weapon": "The Naked Gun" },
      { "Every regal's males": "All the King's Men" },
      { "a triste to recollect": "An Affair to Remember" },
      { "conflct and harmony": "War and Peace" },
      { "prickled feathered friends": "Thorn Birds" },
      { "the ancient male and the ocean": "The Old Man and the Sea" },
      { "huge hopes": "Great Expectations" },
      { "a story about 2 towns": "A Tale of Two Cities" },
      { "arrogance and bias": "Pride and Prejudice" },
      { origins: "Roots" },
      { "a dozen irate males": "Twelve Angry Men" },
      { dizziness: "Vertigo" },
      { "backward casement": "Rear Window" },
      { "small females": "Little Women" },
      { "a liason to recall": "An Affair to Remember" },
      { "the red symbol": "The Scarlet Letter" },
      { "the magician's trainee": "The Sorcerer's Apprentice" },
      { "cigarette street": "Tobacco Road" },
      { "courageous ticker": "BraveHeart" },
      { "wounded feature": "Scarface" },
      { "leader of the bands": "Lord of the Rings" },
      { "perish firmly": "Die Hard" },
      { "alcohol morning": "Teguila Sunrise" },
      { "arachnid male": "Spider Man" },
      { "foreign stuff": "Stranger Things" },
      { "wounded storage": "Hurt Locker" },
      { "chilly finger Skywalker": "Cool Hand Luke" },
      { "letter guys": "Xmen" },
      { "talkative communiity": "Social Network" },
      { "furious cow": "Raging Bull" },
      { "moral men": "Goodfellas" },
      { "deadly instrument": "Lethal Weapon" },
      { "basin canines": "Reservoir Dogs" },
      { "stone-like": "Rocky" },
      { "spectre snappers": "Ghost Busters" },
      { "snapped back hilltop": "Brokeback Mountain" },
      { "fiery seats": "Blazing Saddles" },
      { "nearly known": "Almost Famous" },
      { "happy male injested female": "Gladiator" },
      { "dirt pig sunshine": "Groundhog Day" },
      { "dusk street": "Sunset Boulevard" },
      { "ebony chevalier": "Dark Knight" },
      { "limo operator": "Taxi Driver" },
      { "dinosaur playground": "Jurasic Park" },
      { "behind glass": "Rear Window" },
      { "obvious perps": "Usual Suspects" },
      { "saving secretive Gossling": "Saving Private Ryan" },
      { "play tale": "Toy Story" },
      { "battle group": "Fight Club" },
      { "US stunner": "American Beauty" },
      { "distant start": "Fargo" },
      { "royal wife": "Princess Bride" },
      { "sword sprinter": "Blade Runner" },
      { "snap quickly group": "Breakfast Club" },
      { "Shanghai city": "China Town" },
      { "juice fantasy": "Pulp Fiction" },
      { "native crutch": "Citizen Kane" },
      { "scottish female dog": "Lassie" },
      { "king shin atonement": "Shawshank Redemption" },
      { "seething hogwash": "Raging Bull" },
      { "soiled twelve": "Dirty Dozen" },
      { "ghetto mutt elitist": "Slumdog Millionaire" },
      { "forest brochure": "Jungle Book" },
      { "the crook of the backpack pop": "The Thief of Bagdad" },
      { "injest beseech idolize": "Eat Pray Love" },
      { "fumble chiefs": "Bobbleheads" },
      { "assignment inconceivable": "Mission Impossible" },
      { "spouse conflicts": "Bride Wars" },
      { "canyon gal": "Valley Girl" },
      { "melody male": "Music Man" },
      { "deluge fellow": "Rain Man" },
      { "marvel female": "Wonder Woman" },
      { "nuptials crooner": "Wedding Singer" },
      { "world of the monkeys": "Planet of the Apes" },
      { "marvelous mademoiselle": "Super Girl" },
      { "the bare pistol": "The Naked Gun" },
      { "tabby ms.": "Cat Woman" },
      { "noble fowl": "Lady Bird" },
      { "cushion speak": "Pillow Talk" },
      { "the deity dad": "The Godfather" },
      { "gilded digit": "Goldfinger" },
      { "boom globe": "Thunderball" },
      { "brilliant optic": "Goldeneye" },
      { "blue yonder collapse": "Skyfall" },
      { "mentally unbalanced": "Psycho" },
      { "clan land": "Family Plot" },
      { "alien journalist": "Foreign Correspondent" },
      { "ebony correspondence": "Blackmail" },
      { "spotlight panic": "Stage Fright" },
      { "covert operator": "Secret Agent" },
      { "coffin ransacker": "Tomb Raider" },
      { "alluring intellect": "Beautiful Mind" },
      { "cord dude": "Cable Guy" },
      { "unclean tango": "Dirty Dancing" },
      { "scarcely favorable males": "A Few Good Men" },
      { "famine games": "Hunger Games" },
      { "globe of the baboons": "Planet of the Apes" },
      { "heirs of chaos": "Sons of Anarchy" },
      { "few prefer it scalding": "Some Like it Hot" },
      { "quiet of the muttons": "Silence of the Lambs" },
      { "the lanky crimson border": "The Thin Red Line" },
      { "grave forager": "Tomb Raider" },
      { "beneath the Florence orb": "Under the Tuscan Sun" },
      { "argent padding manuscript": "Silver Linings Playbook" },
      { "taste and rationality": "Sense and Sensibility" },
      { "1 soared above the crazy aerie": "One Flew Over the Cuckoo's Nest" },
      { "killer belief": "Assassin Creed" },
      { "beckon of obligation": "Call of Duty" },
      { "a chevaliers story": "A Knights Tale" },
      { "annihilation today": "Apocalypse Now" },
      { "large papa": "Big Daddy" },
      { "newlywed's servants": "Bridesmaids" },
      { "ensemble abroad": "Cast Away" },
      { "transparent and current peril": "Clear and Present Danger" },
      { "mambos with lobos": "Dances with Wolves" },
      { "mutt 24hour teatime": "Dog Day Afternoon" },
      { "the pachyderm male": "The Elephant Man" },
      { "2 x 2 nuptials and a burial": "Four Weddings and a Funeral" },
      { "receive intelligence": "Get Smart" },
      { "constellation pursuit": "Galaxy Quest" },
      { "dudes and raggedy anns": "Guys and Dolls" },
      { "suspend above": "Hangover" },
      { "abode solely": "Home Alone" },
      {
        "trip to the center of the soil": "Journey to the Center of the Earth",
      },
      { "martial arts munchkin": "Karate Kid" },
      { "monarchs oration": "Kings Speech" },
      { "tiny damsel daylight": "Little Miss Sunshine" },
      { "the glorious lucky number": "The Magnificent Seven" },
      { "intersect the sires": "Meet the Parents" },
      { "noon's opposite ranchman": "Midnight Cowboy" },
      { "visionary waterway": "Mystic River" },
      { "barred exit": "No Way Out" },
      { "lions gang and bias": "Pride and Prejudice" },
      { "lawfully fair": "Legally Blonde" },
      { "cruel females": "Mean Girls" },
      { "awesome animals": "Fantastic Beasts" },
      { "the evil dudes": "The Bad Guys" },
      { "arson opener": "Firestarter" },
      { "salvage commandos": "Rescue Rangers" },
      { "head pistol": "Top Gun" },
      { "projectile caboose": "Bullet Train" },
      { "kitten in galoshes": "Puss in Boots" },
      { "metal dude": "The Tin Man" },
      { "panic boast": "The Scarecrow" },
      { "wimpy cat": "The Cowardly Lion" },
      { "scotish female dog": "Lassie" },
      { "medical oddball": "Doctor Strange" },
      { "profound liquids": "Deep Waters" },
      { "arson opener": "Firestarter" },
      { "surpass pistol": "Top Gun" },
      { "the missing metropolis": "The Lost City" },
    ],
    "myth and folklore": [
      { "hideous swan": "Ugly Duckling" },
      { "bird cloak": "RobinHood" },
      { "ruler's recent wardrobe": "The Emperor's New Clothes" },
      { "blizzard royalty": "Snow Queen" },
      { "toad monarch": "Frog Prince" },
      { "snoozing good looker": "Sleeping Beauty" },
      { "area of agreement": "Land of Nod" },
      { "envious ogre": "Green-Eyed Monster" },
      { "gloomy harvester": "Grim Reaper" },
    ],
    "on broadway": [
      { "small store of fear": "Little Shop of Horrors" },
      { "melody guy": "Music Man" },
      { "strange twosome": "Odd Couple" },
      { "the cpugar monarch": "The Lion King" },
      { "the tiny nobleman": "The Little Prince" },
      { "amusing femle": "Funny Girl" },
      { devilish: "Wicked" },
      { "bug extract": "Beetle Juice" },
      { "eden rectangle": "Paradise Square" },
      { "perverted footwear": "Kinky Boots" },
      { "suspended males": "HangMen" },
      { "stunner and the ogre": "Beauty and the Beast" },
    ],
    paintings: [
      { "the final meal": "The Last Supper" },
      { "liquid flowers": "Water Lillies" },
      { "evening guard": "Night Watch" },
      { "the yell": "The Scream" },
    ],
    people: [
      { "medical enchantress": "Witch Doctor" },
      { "orator of the home": "Speaker of the House" },
      { "absolute bench": "Supreme Court" },
      { "parish cliff": "Churchill" },
      { "sleuth hound": "Snoop Dogg" },
      { "half looney": "50 Cent" },
      { "glacial chunk": "Ice Cube" },
      { "permafrost letter": "Ice T" },
      { "officer goat": "Captain Kidd" },
      { "auto cabbie": "Taxi Driver" },
      { "infant male": "Baby Boy" },
      { "rich coiffeur": "Wealthy Barber" },
      { "sagacious males": "Wise Men" },
      { "hassock fowl": "Stool Pigeon" },
      { "lofty bread end": "Upper Crust" },
      { "young male bed": "Boycott" },
      { "blood soaked aorta": "Bleeding Heaarts" },
      { "cinema asterisk": "Movie Star" },
      { "deadly lady": "Femme Fatale" },
      { "enticing woman": "Temptress" },
      { "flogging lad": "Whipping Boy" },
      { "cinema asterisk": "Movie Star" },
      { "cocky male": "Macho Man" },
      { "nuptial crooner": "Wedding Singer" },
      { "blooming painter": "Budding Artist" },
      { "covert spy": "Undercover Agent" },
      { "youthful folks": "Young People" },
      { "blazing male": "Fireman" },
      { "deceased look-a-like": "Dead Ringer" },
      { "large toupee": "BigWig" },
      { "span erector": "Bridge Builder" },
      { "enactment teacher": "Law Professor" },
      { "lawyer bird": "Legal Eagle" },
      { "auto card shuffler": "Car Dealer" },
      { "assigned chauffeur": "Designated Driver" },
      { "tart cook": "Pastry Chef" },
      { "sweepstake champion": "Lottery Winner" },
      { "rose colored beast": "Pink Panther" },
      { "spotless weirdo": "Clean Freak" },
      { "bursting pullover": "Stuffed Shirt" },
      { "musical chief": "Orchestra Leader" },
      { "booze unknown": "Alcohol Anonymous" },
      { "feline crook": "Cat Burglar" },
      { "spiral media": "Spin Doctor" },
      { "wedlock creator": "Wedding Planner" },
      { "female teen leads": "Girl Guides" },
      { "lad counselor": "Boy Scout" },
      { "center kid": "Middle Child" },
      { "crypt miner": "Grave Digger" },
      { "pampered kid": "Spoiled Brat" },
      { "adolescent hoodlum": "Juvenile Delinquent" },
      { "junk stirers": "Rubble Rousers" },
      { "jolt player": "Shock Jock" },
      { "groom's favorite guy": "Best Man" },
      { "bleak pale death": "Grim Reaper" },
      { "banner youngster": "Poster Child" },
      { "appointed motorist": "Designated Driver" },
      { "serious alternative": "Significant Other" },
      { "forgetful teacher": "Absent-Minded Professor" },
      { "breast friend": "Bosom Pal" },
      { "contented tenter": "Happy Camper" },
      { "infant explosion": "Baby Boomer" },
      { "keen doer": "Eager Beaver" },
      { "blare trumpeter": "Whistle Blower" },
      { "gilded miner": "GoldDigger" },
      { "cavalier in bright protection": "Knight in Shining Armor" },
      { "bombastic donkey": "Pompous Ass" },
      { "flushed spouse": "Blushing Bride" },
      { "the metal woman": "The Iron Lady" },
      { "cougar manager": "Lion Tamer" },
      { "span manager": "Time Traveller" },
      { "vault crook": "Bank Robber" },
      { "dialogue author": "Speech Writer" },
      { "cave of crooks": "Den of Thieves" },
      { "infant explosion": "Baby Boomer" },
      { "pellet recorder": "Bean Counter" },
      { "improved partial": "Better Half" },
      { "keen doer": "Eager Beaver" },
      { "professor's favorite": "Teacher's Pet" },
      { "placard youngster": "Poster Child" },
      { "marvelous nova": "Super Star" },
      { "citation medalist": "Trophy Winner" },
      { "Eve, Hillary, Jill": "First Ladies" },
      { "hilly rocks": "Rolling Stones" },
      { "endless dreamer": "Eternal Optimist" },
      { "compatriots and enemies": "Friends and Foe" },
      { "officers and bandits": "Cops and Robbers" },
      { "evil people": "Bad Guys" },
      { "pathway creator": "Trail Blazer" },
      { "clan dude": "Family Guy" },
      { "leopard thickets": "Tiger Woods" },
      { "bird letter": "JayZ" },
      { "statement barrier": "Bill Gates" },
      { "award overrun": "Oscar Wilde" },
      { "gentlewoman batty": "Lady Gaga" },
      { "medical oddball": "Doctor Strange" },
      { "the trotting gastronomist": "The Galloping Gourmet" },
      { "letter ache": "T-Pain" },
      { "medical oddball": "Dr. Strange" },
      { "allies in limbs": "Comrades in Arms" },
      { "daybreak fowl": "Early Bird" },
      { "evening bird": "Night Owl" },
      { "beguiled public": "Captive Audience" },
      { "speaking managers": "Talking Heads" },
    ],
    "places and things": [
      { "map of the hemisphere": "Atlas of the World" },
      { "original grade": "First Class" },
      { nightmare: "Dark Horse" },
      { "lower pooch": "Underdog" },
      { "compartment view": "Pocket Watch" },
      { "community gaze": "Neighborhood Watch" },
      { "boisterous cluster": "Thunder Storm" },
      { "prison dial": "Cell phone" },
      { "effort capsule": "Tripod" },
      { "theatre leader": "Stage Coach" },
      { "stupid clinger": "Dumbbell" },
      { "male appointment": "Mandate" },
      { "cut up": "Crop Top" },
      { "bird tune": "Swan Song" },
      { "month bloom": "Mayflower" },
      { "the considerable barricade": "The Great Wall" },
      { "freedom chime": "Liberty Bell" },
      { "sagacious molars": "Wisdom Teeth" },
      { "guaranteed acreage": "Promised Land" },
      { "Irish rock": "Blarney Stone" },
      { "brilliant decree": "Golden Rule" },
      { "outlawed harvest": "Forbidden Fruit" },
      { "first transgression": "Original Sin" },
      { "khaki twig": "Olive Branch" },
      { "illusion rug": "Magic Carpet" },
      { "spotless blackboard": "Clean Slate" },
      { "always prepared terminal": "Ever Ready Batteries" },
      { "the metal drapes": "The Iron Curtain" },
      { "ancient male organization": "Old Boys Networl" },
      { "rank logo": "Status Symbol" },
      { "grating booze": "Rubbing Alcohol" },
      { "motorists permits": "Driver's License" },
      { "jabbing tote": "Punching Bag" },
      { "awful practices": "Bad Habits" },
      { "fever crest": "Heat Wave" },
      { "terrain surge": "Ground Swell" },
      { "existent creek": "Live Stream" },
      { "foolproof blizzard": "Perfect Storn" },
      { "toad limbs": "Frog Legs" },
      { "regal boat": "Royal Yacht" },
      { "hairless bird": "Bald Eagle" },
      { "nourishment link": "Food Chain" },
      { "blustery waters": "Stormy Seas" },
      { "mute chimes": "Dumbbells" },
      { "delicate self": "Fragile Ego" },
      { "bloodsucking journals": "Vampire Diaries" },
      { "psyche voyage": "Ego Trip" },
      { "packed abode": "Full House" },
      { "untrue dentures": "False Teeth" },
      { "cave of crooks": "Den of Thieves" },
      { "colored rug": "Red Carpet" },
      { "crying structure": "Wailing Wall" },
      { "road illumination": "Street Lights" },
      { "tinted ocean": "Red Sea" },
      { "saloon cryptograph": "Bar Code" },
      { "glutton vault": "Piggy Bank" },
      { "tress catcher": "Hairnet" },
      { "bathroom parchment": "Toilet Paper" },
      { "tepid money": "Cool Cash" },
      { "fake iq": "Artificial Intelligence" },
      { "liquid stumbles": "Waterfalls" },
      { "liquid flowers": "Water Lillies" },
      { "quaduped wisdom": "Horse Sense" },
      { "ape mischief": "Monkey Businesss" },
      { "street atlas": "Road Map" },
      { "frozen square": "Ice Cube" },
      { "digit spike": "Finger Nail" },
      { "spike glaze": "Nail Polish" },
      { "taper luminescence": "Candle Light" },
      { "combative conduct": "Aggressive Behavior" },
      { "human created": "Man Made" },
      { "oleo vessel": "ButterCup" },
      { "municipality yacht": "Township" },
      { "acceleration bang": "Speed Bump" },
      { "ghostly dwelling": "Haunted House" },
      { "kill abode": "Slaughterhouse" },
      { "cave of crooks": "Den of Thieves" },
      { "moron's utopia": "Fool's Paradise" },
      { "observer safeguard": "Witness Protection" },
      { "image of freedom": "Statue of Liberty" },
      { "fruit government": "Banana Republic" },
      { "inhaling area": "Breathing Space" },
      { "pleasure playground": "Amusement Park" },
      { "lockup chamber": "Prison Cell" },
      { "old Italium stadium": "Roman Coliseum" },
      { "hourly block": "Time Square" },
      { "female contact": "Feminine Touch" },
      { "luminary conflicts": "Star Wars" },
      { "molar shovel": "Tooth Pick" },
      { "toboggan chimes": "Sleigh Bells" },
      { "yuletide sapling": "Christmas Tree" },
      { "disguise celebration": "Masquerade Party" },
      { "concealed reception": "masked ball" },
      { "bosom formula": "Breast Milk" },
      { "hasty conduct": "Impulsive Behavior" },
      { "crate blades": "Box Cutters" },
      { "timber abode": "Log House" },
      { "announcement panel": "Bulletin Board" },
      { "cycle lane": "Bike Path" },
      { "trip restriction": "Travel Ban" },
      { "celebration gift": "Party favor" },
      { "wage augmentation": "Salary Increase" },
      { "assignment insurmountable": "Mission Impossible" },
      { "slick utensil": "Greasy Spoon" },
      { "evening horse": "Nightmare" },
      { "stallion molars": "Horse Teeth" },
      { "fowl pen": "Chicken Coop" },
      { "boat devistation": "Ship Wreck" },
      { "buffoon auto": "Clown Car" },
      { "storage dangle": "PodCast" },
      { "duplicate eyesight": "Double Vision" },
      { "capsule crate": "Pill Box" },
      { "naked carcass": "Bare Bones" },
      { "belly jab": "Gut Punch" },
      { "intellect syphon": "Brain Drain" },
      { "goat sleeping": "Kidnapping" },
      { "jail escape": "Prison Break" },
      { "expiring water": "Dead Sea" },
      { "acquiring arc": "Learning Curve" },
      { "untrue banner": "False Flag" },
      { "pinky colored specs": "Rose Colored Glasses" },
      { "cracking headlines": "Breaking News" },
      { "cloudy liquids": "Murky Waters" },
      { "plasma shower": "Blood Bath" },
      { "doggy affection": "Puppy Love" },
      { "velvety blemish": "Soft Spot" },
      { "infant pram": "Baby Carriage" },
      { "slum cannon": "Ghetto Blaster" },
      { "test blimp": "Trial Balloon" },
      { "atmospheric adjustment": "Climate Change" },
      { "stealth aggression": "Sneak Attack" },
      { "exhaust net": "Smoke Screen" },
      { "beast proportion": "Lion Share" },
      { "document route": "Paper Trail" },
      { "scare peddling": "Fear Mongering" },
      { "harmony lectures": "Peace Talks" },
      { "celebration gifts": "Party Favors" },
      { "artery hindrance": "Road Block" },
      { "large ladle": "Big Dipper" },
      { "donut peak": "Muffin Top" },
      { "7 days done": "Weekend" },
      { "metal attitude": "Iron Will" },
      { "sarcastic fowl": "Mocking Bird" },
      { "affiliation abode": "Club House" },
      { "brief response": "Short Answer" },
      { "vermin snare": "Mouse Trap" },
      { "drapery shout": "Curtain Call" },
      { "celebral competence": "Mental Dexterity" },
      { "various selection": "Multiple Choice" },
      { "visionless escort": "Blind Date" },
      { "unsighted safekeeping": "Blind Trust" },
      { "memo catalogue": "Notebook" },
      { "crucial petrols": "Essential Oils" },
      { "breakout cover": "Escape Hatch" },
      { "bees lair": "Hornets Nest" },
      { "confection molar": "Sweet Tooth" },
      { "finishing program": "Final Course" },
      { "abandon fanny": "ScuttleButt" },
      { "wedlock rite": "Wedding Ceremony" },
      { "pistol wedlock": "Shotgun Wedding" },
      { "suiters argument": "Lovers Quarrel" },
      { "pinto rear": "Pony Tail" },
      { "meek starts": "Humble Beginnings" },
      { "continuing collision": "Lasting Impact" },
      { "timber block": "Log Jam" },
      { "plasma cash": "Blood Money" },
      { "battle atrocities": "War Crimes" },
      { "blossom capability": "Flower Power" },
      { "bright illustration": "Shining Example" },
      { "sorcerer search": "Witch Hunt" },
      { "break-up pact": "Separation Agreement" },
      { "lofty danger": "High Risk" },
      { "tiara gems": "Crown Jewels" },
      { "Asian high speed": "Orient Express" },
      { "stallion plumes": "Horse Feathers" },
      { "koala justice": "Kangaroo Court" },
      { "drones patellas": "Bees Knees" },
      { "grime sack": "Dirt Bag" },
      { "haul chase": "Drag Race" },
      { "rememberance road": "Memory Lane" },
      { "duct fantasy": "Pipe Dreams" },
      { "valued period": "Quality Time" },
      { "protection covering": "Security Blanket" },
      { "city fiction": "Urban Myth" },
      { "nada patience": "Zero Tolerance" },
      { "prohibited produce": "Forbidden Fruit" },
      { "pail inventory": "Bucket List" },
      { "cemetery switch": "Graveyard Shift" },
      { "nourishment postage": "Food Stamps" },
      { "taut cord": "TightRope" },
      { "snap comfort": "Trapeze" },
      { "yearning reservoir": "Wishing Well" },
      { "blazing chasm": "Fire Pit" },
      { "feline amble": "CatWalk" },
      { "surf breath": "WaveLength" },
      { "separate mesh": "Split screen" },
      { "boxer planes": "Fighter Jets" },
      { "pub seat": "Bar Stool" },
      { "cannister record": "Bucket List" },
      { "portals of Hades": "Gates of Hell" },
      { "universal disease": "global pandemic" },
      { "sailing holiday": "Cruise Vacation" },
      { "comical cartilage": "Funny Bone" },
      { "witches travel": "Broom Stick" },
      { "constructioon slabs": "Building Blocks" },
      { "bulking alloy": "Heavy Metal" },
      { "announcers hammer": "Speaker's Gavel" },
      { "bucks and pennies": "Dollars and Cents" },
      { "swap cutlass": "Switch Blade" },
      { "complete lodging": "Full House" },
      { "placard panel": "Poster Board" },
      { "outer sight": "Peripheral Vision" },
      { "organic timepiece": "Biological Clock" },
      { "mirrored plaster": "Glass Ceiling" },
      { "sheet pathway": "Paper Trail" },
      { "superior existence": "Quality Time" },
      { "computerized truth": "Virtual Reality" },
      { "speech correspondence": "Voice Mail" },
      { "amazing finish": "Surprise Ending" },
      { "awkward time": "Embarrassing moment" },
      { "college acolade": "Academy Award" },
      { "transparent sphere": "Crystal Ball" },
      { "crystal carving": "Ice Sculpture" },
      { "gnat repulsive": "Bug Repellent" },
      { "wacky ticker": "Cuckoo Clock" },
      { "author's obstruction": "Writer's Block" },
      { "inactive span": "Suspension Bridge" },
      { "blended feelings": "Mixed Emotions" },
      { "shaggy clasp": "Bear Hug" },
      { "bulky ticker": "Heavy Heart" },
      { "lengthy image": "Long Face" },
      { "outburst anger": "Temper Tantrum" },
      { "enchanted existence": "Charmed Life" },
      { "repair barricades": "Mend Fences" },
      { "trivial currency": "Petty Cash" },
      { "brooch moola": "Pin Money" },
      { "bitter compassion": "Cold Comforrt" },
      { "frigid tootsies": "Cold Feet" },
      { "absolute disarray": "Complete Shambles" },
      { "wafer blade": "Cookie Cutter" },
      { "computing flock": "Counting Sheep" },
      { "rulers baubles": "Crown Jewels" },
      { "dust purse": "Dirt Bag" },
      { "syrupy claws": "Sticky Fingers" },
      { "baboon enterprise": "Mokey Business" },
      { "foam shower": "Bubble Bath" },
      { "crisis place": "Emergency Room" },
      { "flaming ashes": "Burning Embers" },
      { "blaze practice": "Fire Drill" },
      { "alarm seizure": "Panic Attack" },
      { "queries and responses": "Questions and Answers" },
      { "bogus banner": "False Flag" },
      { "penitentiary escape": "Prison Break" },
      { "badge of distinction": "Medal of Honor" },
      { "camper playground": "Trailer Park" },
      { "verified tales": "True Stories" },
      { "alien trysts": "Foreign Affairs" },
      { "vessel distruction": "Ship Wreck" },
      { "officer capture": "Police Raid" },
      { "sow rear": "Piggy-Back" },
      { "swine rear": "PigTail" },
      { "collateral store": "Pawn Shop" },
      { "solid clue": "Credible Evidence" },
      { "evening stallion": "Nightmare" },
      { "cord of beads": "String of Pearls" },
      { "hornet attack": "Bee Sting" },
      { "eerie feature": "Spookie Movie" },
      { "unknown stuff": "Stranger Things" },
      { "truth or fantasy": "Fact or Fiction" },
      { "head incision": "Brain Surgery" },
      { "highway voyage": "Road Trip" },
      { "frigid assets": "Cold Cash" },
      { "wide street bomb": "Broadway Flop" },
      { "aiding grip": "Helping Hand" },
      { "fuzzy contours": "Blurred Lines" },
      { "sorcerer's chase": "Witch Hunt" },
      { "torch call": "Burner Phone" },
      { "back street kitty": "Alley Cat" },
      { "arouse the mammal": "Wake the Bear" },
      { "unrevealed vote": "Secret Ballot" },
      { "charged roadster": "Electric Car" },
      { "prostrate seat": "Reclining Chair" },
      { "playground pole": "YardStick" },
      { "colliding autos": "Bumping Cars" },
      { "untamed fowl hunt": "Wild Goose Chase" },
      { "venomous reptiles": "Poisonous Snakes" },
      { "cash spin": "Coin Toss" },
      { "juvenile concern": "Child Care" },
      { "slab and cement": "Brick and Mortar" },
      { "scholar liability": "Student Debt" },
      { "permanent earnings": "Fixed Income" },
      { "shattering information": "Breaking News" },
      { "accuracy or results": "Truth or Consequences" },
      { "cushion brawl": "Pillow Fight" },
      { "momentous occurrence": "Historic Event" },
      { "exclusive estate": "Private Property" },
      { "desirous reasoning": "Wishful Thinking" },
      { "twinklers and vertical lines": "Stars and Stripes" },
      { "test by tribunal": "Trial by Jury" },
      { "measuring your endurance": "Testing Your Patience" },
      { "convert costs": "Hidden fees" },
      { "rule of morality": "Code of Ethics" },
      { "upright bravos": "Standing Ovation" },
      { "peril unrestricted": "Risk Free" },
      { "absolute aim": "Ultimate Goal" },
      { "income increase": "Pay Raise" },
      { "labor depots": "Work Stations" },
      { "completion hubs": "Fulfillment Centers" },
      { "petrol boozeer": "Gas Guzzlers" },
      { "doubtful intelligence": "Dubious Minds" },
      { "boot trumpet": "Shoe Horn" },
      { "exhaust bundle": "smoke stack" },
      { "threefold peril": "Triple Threat" },
      { "choosy recollection": "Selective Memory" },
      { "gap of thought": "Lapse of Memory" },
      { "harsh alert": "Stern Warning" },
      { "bony clue": "Skeleton Key" },
      { "gaunt plunge": "Skinny-Dip" },
      { "route wave": "Circuit Breaker" },
      { "careless speed": "Reckless Driving" },
      { "lockup chamber": "Prison Cell" },
      { "entreaty agreement": "Plea Bargain" },
      { "disinformation conflict": "Propaganda War" },
      { "beastly stamina": "Brute Strength" },
      { "middle ring": "Inner Circle" },
      { "weather alteration": "Climate Change" },
      { "rule of appeal": "Law of Attraction" },
      { "fighter tortoises": "Ninja Turtles" },
      { "restricted real estate": "Private Property" },
      { "icon of freedom": "Statue of Liberty" },
      { "attack association": "Fight Club" },
      { "sunset area": "Twilight Zone" },
      { "old Italian stadium": "Roman Coliseum" },
      { "tall acceleration": "High Speed" },
      { "Spin and Shaft": "Reel and Rod" },
      { "trash letters": "Junk Mail" },
      { "booster system": "Rocket Science" },
      { "plea rosaries": "Prayer Beads" },
      { "unpaid dialogue": "Free Speech" },
      { "Allah's reward": "God's gift" },
      { "dwindle cover": "Shrink Wrap" },
      { "award stag": "Prize Bull" },
      { "young horse's appendage": "Ponytail" },
      { "asset benefit": "Stock Option" },
      { "grade procedure": "Class Action" },
      { "slab link": "Blockchain" },
      { "rule of appeal": "Law of Attraction" },
      { "crimson banner": "Red Flag" },
      { "biography in bravery": "Profiles in Courage" },
      { "ashen dominance": "White Supremacy" },
      { "hanging lobe circles": "Dangling Earrings" },
      { "corpse of fibs": "Body of Lies" },
      { "rule of appeal": "Law of Attraction" },
      { "trick of eyesight": "Optical Illusion" },
      { "distant rule": "Remote Control" },
      { "dwelling jog": "Home Run" },
      { "blaze stone": "Firepit" },
      { "small nymph": "Little Mermaid" },
      { "sculpture of freedom": "Statue of Liberty" },
      { "accessibility shop": "Convenience Store" },
      { "female pest": "Lady Bug" },
      { "fake blooms": "Artificial Flowers" },
      { "resident's capture": "Citizen's Arrest" },
      { "tummy fastener": "Belly Button" },
      { "solid money": "Hard Cash" },
      { "detached artillery": "Loose Canon" },
      { "hasty conduct": "Impulsive Behaviour" },
      { "elegant trouserrs": "Fancy Pants" },
      { "patella dope": "Knee Jerk" },
      { "wharf illumination": "Harbor Lights" },
      { "thoroufare fury": "Road Rage" },
      { "cycle lane": "Bike Path" },
      { "trip restriction": "Travel Ban" },
      { "unseen replica": "Blind Copy" },
      { "soiled pooch": "Dirty Dog" },
      { "neighbourhood champ": "Local Hero" },
      { "strange paid": "Odd Couple" },
      { "quack broth": "Duck Soup" },
      { "treasury safe": "Bank Vault" },
      { "stomach lard": "Belly Fat" },
      { "fruit dog": "Melancholy" },
      { "warm spud": "Hot Potato" },
      { "molar shovel": "Tooth Pick" },
      { "poultry fodder": "Chicken Feed" },
      { "blooming painter": "Budding Artist" },
      { "spewing geyser": "Erupting Volcano" },
    ],
    slang: [
      { "lease comp": "Rent Free" },
      { "mood analysis": "Vile Check" },
      { "principal type": "Main Character" },
      { "laid back": "Low Key" },
      { "altogether baffled": "Totally Clueless" },
      { "kitten altercation": "Cat Fight" },
      { "gorilla enterprise": "Monkey Business" },
      { "mix nut": "Stir Crazy" },
      { "bang douse": "Slam Dunk" },
      { "tiny saute": "Small Fry" },
      { "buttock's knock": "Bum Rap" },
      { "stallion's behind": "Horse's Ass" },
      { "celebration beast": "Party Animal" },
      { "drones patellas": "Bees Knees" },
      { "bash immersion": "Slam Dunk" },
      { "large toupee": "Big Wig" },
      { "grizzly inferno": "Bloody Hell" },
      { "fortunate cadaver": "Lucky Stiff" },
      { "brainy biscuit": "Smart Cookie" },
      { "cool tablet": "Chill Pill" },
      { "smelly wealth": "Stinking Rich" },
      { "clever donkey": "Smart Ass" },
      { "burro eons": "Donkey Years" },
      { "bounce fowl": "Spring Chcken" },
    ],
    songs: [
      { "adolescent seraph": "Teen Angel" },
      { "submerge the German sub": "Sink the Bismark" },
      { "shackle mob": "Chain Gang" },
      { "over the ocean": "Beyond the Sea" },
      { "balustrade to paradise": "Stairway to Heaven" },
      { "female chance": "Lady Luck" },
      { "cash cash cash": "Money Money Money" },
      { "masculine male": "Macho Man" },
      { "the women is a hobo": "The Lady is a Tramp" },
      { "colored submersible": "Yellow Submarine" },
      { "shed no tears for this country": "Don't Cry for me Argentina" },
      { "chicken of the region": "Coward of the County" },
      { "you spark my existence": "You Light Up My Life" },
      { "span across woried liquid": "Bridge Over Troubled Waters" },
      { "gusting in the breeze": "Blowing in the Wind" },
      { "scale each peak": "Climb Every Mountain" },
      { "the big cat slumbers this evening": "The Lion Sleeps Tonight" },
      { "torch the precipitation": "Set Fire to the Rain" },
      { "cost label": "Price Tag" },
      { "pursuing autos": "Chasing Cars" },
      { "awful relationship": "Bad Romance" },
      { "dance around the timepiece": "Rock Around the Clock" },
      { rrecollections: "Memories" },
      { "flaming ties": "Scarlet Ribbons" },
      { "woman in crimson": "Lady in Red" },
      { insane: "Crazy" },
      { "unshackled tune": "Unchained Melody" },
      { forever: "Always" },
      { "female companion": "Girlfriend" },
      { "large females don't shed tears": "Big Girls Don't Cry" },
      { "captain of the crowd": "Leader of the Pack" },
      { "whiff the illusionary hydra": "Puff the Magic Dragon" },
      { "clang chimers": "Jingle Bells" },
      { "tiny beating lad": "Little Drummer Boy" },
      { "tinkle cymbal slab": "Jingle Bell Rock" },
      { "ascend each hill": "Climb Every Mountain" },
      { "I abhor this day": "I Hate Mondays" },
      { "the champ seizes fully": "The Winner Take it All" },
      { "validity or taunt": "Truth or Dare" },
      { "taxi chauffeur": "Cab Driver" },
      { "destroying globe": "Wrecking Ball" },
      { "unrealistic hope": "Pipe Dream" },
      { "lease comp": "Rent Free" },
      { "veracity cuts": "Truth Hurts" },
      { "inexpensive pleasure": "Cheap Thrills" },
      { "disco ape": "Dance Monkey" },
      { "glaring rays": "Blinding Lights" },
      { "I desire to snap rescued": "I Want to Break Free" },
      { "projectile male": "Rocket Man" },
      { "eternally youthful": "Forever Young" },
      { "jiving royalty": "Dancing Queen" },
      { "prison stone": "Jailhouse Rock" },
      { "detached tune": "Unchained Melody" },
      { "sweet sweet": "Sugar Sugar Sugar" },
      { "hushed evening": "Silent Night" },
      { "this female is ablaze": "This Girl's on Fire" },
    ],
    toys: [
      { "blazing autos": "Hot Wheels" },
      { "fluffy play things": "Plush Toys" },
      { "claw guard": "Paw Patrol" },
      { "confection area": "Candy Land" },
      { "moppet's home": "Doll House" },
      { "leap cord": "Jump Rope" },
      { "projectile panel": "Dart Board" },
      { "clapboard maze": "Wooden Puzzle" },
      { "liquid pistol": "Water Gun" },
      { "anxiety sphere": "Stress Ball" },
      { "eternal square": "Infinity Cube" },
      { "jabbing gear": "Punching Bag" },
      { "digit marionettes": "Finger Puppets" },
      { "parchment jet": "Paper Airplane" },
      { "labels versus mankind": "Cards Against Humanity" },
      { "melody box": "Music Box" },
      { "glide crate": "SkateBoard" },
      { "interior match play": "Indoor Golf" },
      { "oar globe": "Paddle Ball" },
      { "raise twigs": "Pick-up Sticks" },
      { "revolving first": "Wooden Top" },
      { "wool moppet": "Felt Doll" },
      { "sweet gadget": "Candy Machine" },
      { "force squadron": "Power Rangers" },
    ],
    "tv shows": [
      { "large noisy explanation": "Big Bang Theory" },
      { "reckless homemaker": "Desperate Housewives" },
      { "broken skyscraper": "Fawlty Towers" },
      { "clan connection": "Family Ties" },
      { "loyal plasma": "True Blood" },
      { "rules and regulations": "Law and Order" },
      { "stoney rocks": "Flintstones" },
      { "clan fight": "Family Feud" },
      { "seedy road": "Sesame Street" },
      { "brimming habitat": "Full House" },
      { "household fellow": "Family Guy" },
      { "awed time": "Wonder Years" },
      { "bright ladies": "Golden Girls" },
      { "strolling cadavers": "Walking Dead" },
      { "insane males": "Mad Men" },
      { "parting evil": "Breaking Bad" },
      { "wealth robbery": "Money Heist" },
      { "boodle stash": "Counterfeit Money" },
      { "goofs coins": "Chump Change" },
      { "inferno's gallery": "Hells Kitchen" },
      { "chief toddler": "Boss Baby" },
      { "ferocious fish enclosure": "Shark Tank" },
      { "contact the media": "Meet the Press" },
      { "condition chamber": "Situation Room" },
      { "U.S. superstar": "American Idol" },
      { "the moral spouse": "The Good Wife" },
      { "Contented ages": "Happy Days" },
      { "valid days": "Good Times" },
      { "path stroll dominion": "Boardwalk Empire" },
      { "the legitimate Globe": "The Real World" },
      { "domicile of posters": "House of Caards" },
      { "cliff road depression": "Hill Street Blues" },
      { "weirdos and nerds": "Freaks and Geeks" },
      { "restrain your excitement": "Curb Your Enthusiasm" },
      { "famous expedition": "Star Trek" },
      { "half a dozen hooves below": "Six Feet Under" },
      { "the letter annals": "The X Files" },
      { "duplicate pinnacles": "Twin Peaks" },
      { "ensemble of siblings": "Band of Brothers" },
      { "globe of terrain": "Planet Earth" },
      { "exterior area": "Outer Range" },
      { "jailed advancement": "Arrested Development" },
      { "everyone in the clan": "All in the Family" },
      { "dusk region": "Twilight Zone" },
      { "plaything of royalty": "Game of Thrones" },
      { "honcho kid": "Boss Baby" },
    ],
  },
};

export default constants;
